import React, { useEffect, useState } from "react";
import {
    Button,
    Row,
    Col,
    Table,
    Input,
    Form,
    DatePicker,
    notification,
} from "antd";
import { v4 as uuidv4 } from "uuid";
import { DeleteOutlined } from "@ant-design/icons";
import { CiSquarePlus } from "react-icons/ci";
import TextArea from "antd/es/input/TextArea";
import { blformService, loadingPlanService } from "../../../services";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

function Add() {
    const { id } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [blForm, setblForm] = useState([]);
    const [particulars, setParticulars] = useState([]);
    const navigate = useNavigate();

    const handleInputChange = (e, index, field) => {
        const { value } = e.target;

        setParticulars((prevDataSource) => {
            // Create a deep copy of the previous data source
            const updatedDataSource = [...prevDataSource];

            // Handle vehicle-related fields dynamically
            if (field.startsWith("vehicle.")) {
                const vehicleField = field.split(".")[1]; // Extract field name after 'vehicle.'

                updatedDataSource[index].vehicles = updatedDataSource[index].vehicles.map((vehicle) => ({
                    ...vehicle,
                    [vehicleField]: value, // Update dynamically
                }));
            } else {
                // Handle other fields (like shipper details)
                updatedDataSource[index] = {
                    ...updatedDataSource[index],
                    [field]: value,
                };
            }

            return updatedDataSource;
        });
    };


    // const handleInputChange = (e, index, field) => {
    //     console.log(particulars)
    //     console.log(e.target.value)
    //     // console.log(e.target.value, index, field)
    //     // console.log(particulars[index].vehicles)
    //     const { value } = e.target;

    //     setParticulars((prevDataSource) => {
    //         // Create a deep copy of the previous data source
    //         const updatedDataSource = [...prevDataSource];

    //         // Update the specific vehicle description
    //         if (field === "vehicle.description") {
    //             updatedDataSource[index].vehicles = updatedDataSource[index].vehicles.map((vehicle, vehicleIndex) => {
    //                 if (vehicleIndex === index) {
    //                     return {
    //                         ...vehicle,
    //                         description: value, // Update the description field
    //                     };
    //                 }
    //                 return vehicle;
    //             });
    //         }



    //         return updatedDataSource;
    //     });
    // };


    const columns = [
        {
            title:
                "Exporter (Principal or seller-licensee and address including ZIP Code)",
            dataIndex: "exporter_info",
            key: "exporter_info",
            width: 200,
            render: (text, record, index) => (
                <div>
                    <Input
                        placeholder="Shipper"
                        value={record.name || ""}
                        onChange={(e) => handleInputChange(e, index, "name")}
                        style={{ width: "100%", marginBottom: "8px" }}
                    />
                    <Input
                        placeholder="Shipper Email"
                        value={record.email || ""}
                        onChange={(e) => handleInputChange(e, index, "email")}
                        style={{ width: "100%", marginBottom: "8px" }}
                    />
                    <TextArea
                        placeholder="Shipper Address"
                        value={record.address || ""}
                        onChange={(e) => handleInputChange(e, index, "address")}
                        style={{ width: "100%", marginBottom: "8px" }}
                    />
                    <Input
                        placeholder="Shipper Phone"
                        value={record.phone || ""}
                        onChange={(e) => handleInputChange(e, index, "phone")}
                        style={{ width: "100%" }}
                    />
                </div>
            ),
        },
        {
            title: "Number of Packages",
            dataIndex: "quantity",
            key: "quantity",
            width: 200,
            render: (text, record, index) => (
                <Input
                    onChange={(e) => handleInputChange(e, index, "vehicle.quantity")}
                    style={{ width: "100%" }}
                />
            ),
        },
        {
            title: "Description of Commodities in Schedule B Detail",
            dataIndex: "description",
            key: "description",
            width: 200,
            render: (text, record, index) => {
                const vehicleDetails = record.vehicles?.map(vehicle => {
                    return `${vehicle.year || ""} ${vehicle.vehicle || ""} ${vehicle.product || ""} - VIN # ${vehicle.chasis_no || ""}`;
                }).join("\n");  // Joining details with new lines

                const value = record.vehicles?.map((vehicle) => vehicle.value).join("\n");

                return (
                    <div
                        style={{ display: "flex", flexDirection: "column", width: "100%" }}
                    >
                        <TextArea
                            defaultValue={vehicleDetails || ""}
                            onChange={(e) => handleInputChange(e, index, "vehicle.description")}
                            placeholder="Description"
                            style={{ marginBottom: "8px" }}
                        />
                        <Input
                            defaultValue={record.itn_number || ""}
                            onChange={(e) => handleInputChange(e, index, "vehicle.itn_number")}
                            placeholder="ITN Number"
                            style={{ marginBottom: "8px" }}
                        />
                        <TextArea
                            defaultValue={value || ""}
                            onChange={(e) => handleInputChange(e, index, "vehicle.value")}
                            placeholder="Value"
                            style={{ marginBottom: "8px" }}
                        />
                    </div>
                )
            },
        },
        {
            title: "Gross Weight",
            dataIndex: "weight",
            key: "weight",
            width: 200,
            render: (text, record, index) => {
                const weight = record.vehicles?.map((vehicle) => vehicle.weight).join("\n");
                return (
                    <TextArea
                        defaultValue={weight || ""}
                        onChange={(e) => handleInputChange(e, index, "vehicle.weight")}
                        style={{ width: "100%" }}
                    />
                )
            },
        },
        {
            title: "Measurement",
            dataIndex: "measurements",
            key: "measurements",
            width: 200,
            render: (text, record, index) => {
                const measurements = record.vehicles?.map((vehicle) => vehicle.measurements).join("\n");
                return (
                    <TextArea
                        defaultValue={measurements || ""}
                        onChange={(e) => handleInputChange(e, index, "vehicle.measurements")}
                        style={{ width: "100%" }}
                    />
                )
            },
        },
        {
            title: "Delete",
            key: "Delete",
            render: (text, record, index) => {
                if (particulars.length === 1) return null;
                return (
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => handleDeleteRow(record.id)}
                    >
                        <DeleteOutlined />
                    </Button>
                );
            },
        },
    ];

    const handleAddRow = () => {
        setParticulars([
            ...particulars,
            {
                id: uuidv4(),
                name: "",
                address: "",
                email: "",
                phone: "",
                vehicles: [
                    {
                        BOS: "",
                        arrival_date: "",
                        bol: "",
                        booking_no: "",
                        buying_charges: "",
                        car_status: "",
                        carrier_name: "",
                        chasis: "",
                        chasis_no: "",
                        container_no: "",
                        container_size: "",
                        created_at: "",
                        cutting_car: "",
                        date_rcd: "",
                        description: "",
                        destination: "",
                        engine_type: "",
                        file_ref: "",
                        freight_charges: "",
                        gallery: [],
                        id: "",
                        images: [],
                        invoice_amount: "",
                        invoice_no: "",
                        itn_number: "",
                        keys: "",
                        labour: "",
                        loading_charges: "",
                        'lot_#': "",
                        material: "",
                        measurements: "",
                        notes: "",
                        quantity: "",
                        operating_port: "",
                        price: "",
                        product: "",
                        quotation_id: "",
                        release_status: "",
                        selling_charges: "",
                        shipping_class_id: "",
                        storage: "",
                        title: "",
                        title_number: "",
                        title_owner: "",
                        title_state: "",
                        towing_charges: "",
                        towing_location: "",
                        tracking_no: "",
                        transportation: "",
                        updated_at: "",
                        user_id: "",
                        value: "",
                        vehicle: "",
                        vehicle_type: "",
                        weight: "",
                        yard_charges: "",
                        year: "",
                    },
                ],
            },
        ]);

        // setParticulars([
        //     ...particulars,
        //     {
        //         id: uuidv4(),
        //         shipper: "",
        //         shipper_address: "",
        //         shipper_email: "",
        //         shipper_phone: "",
        //         quantity: "",
        //         description: "",
        //         itn_number: "",
        //         value: "",
        //         weight: "",
        //         measurements: "",
        //     },
        // ]);
    };

    const handleDeleteRow = (id) => {
        setParticulars(particulars.filter((item) => item.id !== id));
    };

    const onFinish = async (values) => {
        setLoading(true)
        const descriptions = particulars.flatMap((item) => item.vehicles?.map((vehicle) => vehicle.description) || [])
        const uniqueDescriptions = [...new Set(descriptions)];
        const data = {
            ...values,
            closing_date: values.closing_date ? dayjs(values.closing_date).format("YYYY-MM-DD") : "",
            party_tel: values.party_tel,
            party: values.party_tel,
            booking_no: id,
            shipper: particulars.map((item) => item.name),
            shipper_address: particulars.map((item) => item.address),
            shipper_email: particulars.map((item) => item.email),
            shipper_phone: particulars.map((item) => item.phone),
            quantity: particulars.flatMap((item) => item.vehicles?.map((vehicle) => vehicle.quantity) || []),
            description: uniqueDescriptions,
            weight: particulars.map(item =>
                [...new Set(item.vehicles?.flatMap(vehicle => vehicle.weight) || [])].join("\n")
            ),
            measurements: particulars.map(item =>
                [...new Set(item.vehicles?.flatMap(vehicle => vehicle.measurements) || [])].join("\n")
            ),
            itn_number: particulars.map((item) => item.itn_number),
            value: particulars.map(item =>
                [...new Set(item.vehicles?.flatMap(vehicle => vehicle.value) || [])].join("\n")
            ),
        };
        // console.log(data)
        const response = await blformService.createForm(data);
        setLoading(false)
        if (response.success) {
            notification.success({
                message: "Successfully Updated!",
                description: response.message,
                placement: "topRight"
            })
            navigate(`/operations/bl-forms`)
        }
    };

    const initialize = async () => {
        const { success, data } = await loadingPlanService.getBLform(id);
        if (success) {
            setblForm(data);

            // Process customers and update vehicles array
            const customersWithUpdatedVehicles = data.customers.map((customer) => {
                const combinedDescription = customer.vehicles.map(vehicle =>
                    `${vehicle.year || ""} ${vehicle.vehicle || ""} (${vehicle.product || ""}) - VIN: ${vehicle.chasis_no || ""}`
                ).join("\n");

                // Assign the combined description to only the first vehicle in the array
                const updatedVehicles = customer.vehicles.map((vehicle, index) => ({
                    ...vehicle,
                    description: combinedDescription, 
                    itn_number: vehicle.itn_number || "" 
                }));

                return {
                    ...customer,
                    vehicles: updatedVehicles
                };
            });

            setParticulars(customersWithUpdatedVehicles);
            form.setFieldsValue({
                agent: "CTRADE USA INC. 7815 SNOWDEN ST, HOUSTON-TX, 77028",
                port: "HOUSTON, TX.",
                container_nos: data.blForm.c_container_number
            });
        }
    };

    useEffect(() => {
        initialize();
    }, []);

    return (
        <>
            <Row gutter={24} wrap={false}>
                <Col flex="280px">
                    <div
                        style={{
                            paddingTop: "8px",
                            paddingRight: "8px",
                            paddingLeft: 8,
                            border: "1px solid #ccc",
                            borderRadius: 5,
                            backgroundColor: "#FFFFFF",
                        }}
                    >
                        <Row gutter={24} style={{ padding: 10 }}>
                            <Col xs={24} sm={24} lg={24} className="mb-4">
                                <h1 style={{ fontWeight: "bolder" }}>
                                    Exporter (Principal or seller-licensee and address including
                                    ZIP Code)
                                </h1>
                                <p className="mt-5">
                                    {blForm?.customers?.map((item, index) => (
                                        <div key={index}>{item.name}</div>
                                    ))}
                                </p>
                            </Col>
                            <Col xs={24} sm={24} lg={24}>
                                <h1 style={{ fontWeight: "bolder" }}>
                                    Document No. (Carrier Booking No.)
                                </h1>
                                <p className="mt-5">{id}</p>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col flex="1">
                    <div
                        style={{
                            padding: "15px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            backgroundColor: "#FFFFFF",
                        }}
                    >
                        <Form
                            // requiredMark={false}
                            layout="vertical"
                            form={form}
                            onFinish={onFinish}
                            labelCol={{ flex: "50px" }} // Allocate a fixed width for labels
                            wrapperCol={{ flex: "1" }}
                        >
                            <Row gutter={24} style={{ padding: 20 }}>
                                <Col span={8}>
                                    <Form.Item label="Consigned To:" name="consignee">
                                        <TextArea placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <Form.Item
                                            label="Notify Party / Intermediate Consignee (Name/Tel):"
                                            name="party"
                                        >
                                            <Input placeholder="Enter Name" />
                                        </Form.Item>
                                        <Form.Item
                                            // label="Telephone:"
                                            name="party_tel"
                                        >
                                            <Input placeholder="Enter Telephone" />
                                        </Form.Item>
                                    </div>
                                </Col>

                                <Col span={8}>
                                    <Form.Item label="Bill of Loading No" name="loading_no">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Export References "
                                        name="export_references"
                                    >
                                        <Input placeholder="" disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Reference No" name="reference_no">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Forwarding Agent (Name and Address)"
                                        name="agent"
                                    >
                                        <TextArea placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Point (State) or Origin or FTZ Number "
                                        name="point"
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Also Notify and/or Additional Routing Instructions"
                                        name="party_instructions"
                                    >
                                        <TextArea placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Loading Pier / Terminal"
                                        name="loading_pier_terminal"
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Type of Move" name="type_of_movement">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Containerized(Vessel only) "
                                        name="containerized"
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Pre-Carriage By" name="carriage">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Place of Receipt by Pre-Carrier "
                                        name="place_of_reciept"
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Exporting Carrier" name="exporting_carrier">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Port of Loading/Export " name="port">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Foreign Port of Unloading (vessel and air only)"
                                        name="discharge"
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Place of Delivery by On-Carrier"
                                        name="place_of_delivery"
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Closing Date"
                                        name="closing_date"
                                    >
                                        <DatePicker placeholder="YYYY-MM-DD" style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row
                                gutter={24}
                                style={{ margin: "6px", backgroundColor: "#FBFBFB" }}
                            >
                                <Col span={24}>
                                    <div className="p-2" style={{ border: "1px solid #ccc" }}>
                                        <h1>Particulars Furnished by Shipper Add Shipper</h1>
                                    </div>
                                    <div style={{ border: "1px solid #ccc" }}>
                                        <Table
                                            columns={columns}
                                            dataSource={particulars}
                                            scroll={{ x: "max-content" }}
                                            pagination={false}
                                            style={{ marginTop: "5px" }}
                                        />
                                    </div>
                                    <div
                                        style={{ marginTop: 20 }}
                                        className="flex flex-col justify-center items-center"
                                    >
                                        <CiSquarePlus
                                            style={{ cursor: "pointer", fontSize: "25px" }}
                                            onClick={handleAddRow}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={24} style={{ padding: 20 }}>
                                <h1
                                    style={{ fontWeight: "bolder", fontSize: "14px" }}
                                    className="mt-5 ml-3 mb-5"
                                >
                                    Marks and Numbers
                                </h1>

                                <Col span={24}>
                                    <Form.Item label="CONTAINER NO:" name="container_nos">
                                        <Input placeholder="" style={{ width: "35%" }} readOnly />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item label="SEAL:" name="seal_nos">
                                        <Input placeholder="" style={{ width: "35%" }} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item label="" name="note_1">
                                        <TextArea
                                            placeholder="This is to certify that all the vehicles inside this container have been drained of fuel and run until stalled.
Batteries have been disconnected and cables taped back to prevent movement & electrical short."
                                            rows={4}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item label="" name="note_2">
                                        <TextArea placeholder="Special Note" rows={4} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row
                                gutter={24}
                                style={{
                                    //   marginTop: 10,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    padding: "20px",
                                }}
                            >
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        size="large"
                                        htmlType="submit"
                                        loading={loading}
                                        style={{ width: "100%", borderRadius: "16px" }}
                                    >
                                        Add Doc
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>
        </>
    );
}
export default Add;
